import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HandleAdditionalInfoChangeFunction } from "../../types/editOrder";
import CommonTextField from "../../../../common/components/functional/commonTextField/CommonTextField";
import InfoTooltip from "../../../../common/components/functional/InfoTooltip/InfoTooltip";

type Props = {
  descriptionToEezyAndCustomerDisabled: boolean;
  descriptionToEezyAndCustomerAndTalentDisabled: boolean;
  info: {
    descriptionToEezyAndCustomer: string;
    descriptionToEezyAndCustomerAndTalent: string;
  };
  handleInfoChange: HandleAdditionalInfoChangeFunction;
};

export const AdditionalInformation = ({
  descriptionToEezyAndCustomerDisabled,
  descriptionToEezyAndCustomerAndTalentDisabled,
  info,
  handleInfoChange,
}: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid
        container
        item
        xs={3}
        justifyContent="flex-end"
        alignItems="center"
        sx={{ marginBottom: "20px" }}
      >
        <Typography variant="secondary">{t("common:message")}</Typography>
      </Grid>
      <Grid item xs={9}>
        <CommonTextField
          disabled={descriptionToEezyAndCustomerDisabled}
          fullWidth
          size="small"
          value={info.descriptionToEezyAndCustomer}
          name="descriptionToEezyAndCustomer"
          onChange={(e) => handleInfoChange(e.target.name, e.target.value)}
          helperText={t("order:visibleToCustomerAndEezy")}
          inputProps={{ maxLength: 2048 }}
        />
      </Grid>
      <Grid
        container
        item
        xs={3}
        justifyContent="flex-end"
        alignItems="center"
        sx={{ marginBottom: "20px" }}
      >
        <Box display="flex" alignItems="center" gap="8px">
          <Typography variant="secondary" textAlign="end">
            {t("order:descToEezyAndCustomerAndTalent")}
          </Typography>
          <InfoTooltip
            title={t("order:descToEezyAndCustomerAndTalentNotificationTooltip")}
          />
        </Box>
      </Grid>
      <Grid item xs={9}>
        <CommonTextField
          disabled={descriptionToEezyAndCustomerAndTalentDisabled}
          fullWidth
          size="small"
          multiline
          minRows={4}
          value={info.descriptionToEezyAndCustomerAndTalent}
          name="descriptionToEezyAndCustomerAndTalent"
          onChange={(e) => handleInfoChange(e.target.name, e.target.value)}
          helperText={t("order:descToEezyAndCustomerAndTalentHelper")}
          inputProps={{ maxLength: 2000 }}
        />
      </Grid>
    </>
  );
};
